import {
  getDataEntities,
  getEntity,
} from "legacy/entities/DataTree/DataTreeHelpers";
import { isWidget } from "legacy/workers/evaluationUtils";
import { dynamicVisibility } from "./autoHeight/compositeReflowTypes";
import type { DynamicChanges } from "./autoHeight/compositeReflowTypes";
import type { SetEvaluatedTreeAction } from "legacy/reducers/evaluationReducers/treeReducer";

export function getVisibilityChanges(
  dataTreeChanges: SetEvaluatedTreeAction[],
  deletedWidgetIds: Set<string>,
  hiddenWidgets: Set<string>,
  reflowDisabled: Set<string> = new Set<string>(),
): DynamicChanges {
  const changedWidgetVisibility: DynamicChanges = {};
  dataTreeChanges.forEach((action) => {
    const { deletedEntities: _, ...dataTree } = action.payload.dataTree;
    const entities = getDataEntities(dataTree);
    entities.forEach(({ entity }) => {
      if (isWidget(entity)) {
        const isDeleted = deletedWidgetIds.has(entity.widgetId);
        if (isDeleted || entity.skippedEvaluation) return;
        const disable = reflowDisabled.has(entity.widgetId);
        if (disable) return;

        const entityIsVisible = entity.isVisible ?? true;
        const collapseWhenHidden = entity.collapseWhenHidden ?? false;

        const isVisible = entityIsVisible || collapseWhenHidden === false;
        if (isVisible && hiddenWidgets.has(entity.widgetId)) {
          changedWidgetVisibility[entity.widgetId] = dynamicVisibility(true);
          hiddenWidgets.delete(entity.widgetId);
        } else if (!isVisible && !hiddenWidgets.has(entity.widgetId)) {
          changedWidgetVisibility[entity.widgetId] = dynamicVisibility(false);
          hiddenWidgets.add(entity.widgetId);
        }
      }
    });
  });
  return changedWidgetVisibility;
}

export function getDeletedWidgetIds(
  dataTreeChanges: SetEvaluatedTreeAction[],
): Set<string> {
  const deletedWidgetIds = new Set<string>();
  dataTreeChanges.forEach((action) => {
    const { deletedEntities, ...dataTree } = action.payload.dataTree;
    deletedEntities?.forEach((loc) => {
      const entity = getEntity(loc, dataTree);
      if (isWidget(entity)) {
        deletedWidgetIds.add(entity.widgetId);
      }
    });
  });
  return deletedWidgetIds;
}
